import React, { useState, useEffect } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Box, Card, makeStyles, Container, CardHeader, Button, CardContent, Divider, MenuItem, Grid, InputLabel, Checkbox, TextField, Chip, TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import MaterialTable from 'material-table';
import { LoadingComponent } from '../../../utils/newLoader';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useAlert } from 'react-alert';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import TablePagination from '@material-ui/core/TablePagination';
import Autocomplete from '@material-ui/lab/Autocomplete';
import _ from 'lodash';
import PageHeader from 'src/views/Common/PageHeader';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const screenCode = 'QUOTATION';

export default function QuotationAddEdit() {
  const classes = useStyles();
  const navigate = useNavigate();
  const alert = useAlert();

  const [groups, setGroups] = useState([]);
  const [title, setTitle] = useState("Quotation");
  const [factories, setFactories] = useState([]);
  const [requisitions, setRequisitions] = useState([]);
  const [skuMaster, setskuMaster] = useState([]);
  const [tableData, setTableData] = useState();
  const [open, setOpen] = useState(false);
  const [isCleared, setIsCleared] = useState(false);
  const [QuotationDetailsData, setQuotationDetailsData] = useState([]);
  const [quotationDetails, setQuotationDetails] = useState({
    groupID: 0,
    factoryID: 0,
    requisitionID: 0,
    skuMasterID: 0,
    itemCategoryID: 0,
    itemID: 0,
    supplierID: 0,
    appliedType: 0
  });
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });
  const [selectedRequisitions, setSelectedRequisitions] = useState([]);
  const [groupedDate, setGroupedData] = useState([]);
  const [skuSupplierData, setSkuSupplierData] = useState({});
  const [suppliersAuto, setSuppliersAuto] = useState();
  const [selectAll, setSelectAll] = useState(false);
  const [QuotationNumber, setQuotationNumber] = useState('');
  const [pagination, setPagination] = useState({});

  const handleClick = () => {
    navigate('/app/Quatation/listing')
  };

  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    if (!selectAll) {
      const allRequisitionIds = QuotationDetailsData.map(row => row.requisitionDetailsID);
      setSelectedRequisitions(allRequisitionIds);
    } else {
      setSelectedRequisitions([]);
    }
  };

  const handlePageChange = (skuMasterID, newPage) => {
    setPagination((prev) => ({
      ...prev,
      [skuMasterID]: { ...prev[skuMasterID], page: newPage },
    }));
  };

  const handleLimitChange = (skuMasterID, event) => {
    setPagination((prev) => ({
      ...prev,
      [skuMasterID]: { ...prev[skuMasterID], limit: event.target.value },
    }));
  };

  useEffect(() => {
    trackPromise(getPermissions(), getGroupsForDropdown(),
      generateQuotationNumber());
  }, []);

  useEffect(() => {
    if (quotationDetails.groupID > 0) {
      trackPromise(getFactoriesForDropdown());
    }
    setQuotationDetailsData([]);
  }, [quotationDetails.groupID]);

  useEffect(() => {
    setQuotationDetailsData([]);
    trackPromise(getFactoriesForDropdown());
    setQuotationDetails({
      ...quotationDetails,
      factoryID: '0'
    });
  }, [quotationDetails.groupID]);

  useEffect(() => {
    setQuotationDetails({
      ...quotationDetails,
      requisitionID: 0,
      skuMasterID: 0
    });
    setIsCleared(!isCleared)
    setQuotationDetailsData([])
    trackPromise(getRequisitionsForDropdown());
  }, [quotationDetails.factoryID]);

  useEffect(() => {
    trackPromise(getSKUForDropdown());
  }, [quotationDetails.requisitionID]);

  useEffect(() => {
    const selectedData = QuotationDetailsData.filter((item) =>
      selectedRequisitions.includes(item.requisitionDetailsID)
    );

    const groupedData = selectedData.reduce((acc, item) => {
      if (!acc[item.skuMasterID]) {
        acc[item.skuMasterID] = {
          skuMasterID: item.skuMasterID,
          skuMasterName: item.skuMasterName,
          requisitions: [],
        };
      }
      acc[item.skuMasterID].requisitions.push(item);
      return acc;
    }, {});

    const groupedArray = Object.values(groupedData);
    setGroupedData(groupedArray);
  }, [selectedRequisitions]);

  async function getPermissions() {
    const permissions = await authService.getPermissionsByScreen(screenCode);
    const isAuthorized = permissions.find(p => p.permissionCode === 'VIEWQUOTATION');
    if (!isAuthorized) {
      navigate('/404');
    }
    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: !!permissions.find(p => p.permissionCode === 'GROUPDROPDOWN'),
      isFactoryFilterEnabled: !!permissions.find(p => p.permissionCode === 'FACTORYDROPDOWN')
    });

    setQuotationDetails({
      ...quotationDetails,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    });
  }

  async function getGroupsForDropdown() {
    const groups = await services.getGroupsForDropdown();
    setGroups(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getAllFactoriesByGroupID(quotationDetails.groupID);
    setFactories(factories);
  }

  async function getRequisitionsForDropdown() {
    const requisitions = await services.getAllRequisionsByFactoryID(quotationDetails.factoryID);
    setRequisitions(requisitions);
  }

  async function getSKUForDropdown() {
    const sku = await services.GetItemsByRequisitionFactoryID(quotationDetails.requisitionID);
    setskuMaster(sku);
  }

  async function getQuotationDetails() {
    let model = {
      factoryID: quotationDetails.factoryID,
      requisitionID: quotationDetails.requisitionID,
      skuMasterID: quotationDetails.skuMasterID
    }
    const AllQuotationDetails = await services.GetAllQuotationDetails(model);
    if (AllQuotationDetails.statusCode === 'Success') {
      if (AllQuotationDetails.data.length > 0) {
        const newQuotation = _.cloneDeep(AllQuotationDetails.data)
        setQuotationDetailsData(newQuotation);
      } else {
        alert.error("No Record to Display");
      }
    }
  }

  function handleSupplier(selectedSupplier, event, skuMasterID) {
    if (!selectedSupplier) return;

    setSkuSupplierData((prevData) => {
      const existingSuppliers = prevData[skuMasterID] || [];
      if (existingSuppliers.some(supplier => supplier.supplierID === selectedSupplier.supplierID)) {
        alert.error("This supplier has already been added for this SKU.");
        setIsCleared(!isCleared);
        return prevData;
      }

      const maxSupplierCount = 1;
      if (existingSuppliers.length >= maxSupplierCount) {
        alert.error('Only one supplier can be added per SKU.');
        setIsCleared(!isCleared);
        return prevData;
      }

      return {
        ...prevData,
        [skuMasterID]: [...existingSuppliers, selectedSupplier],
      };
    });
    setIsCleared(!isCleared);
  }

  async function getSuppliersForDropDownAuto(skuMasterID) {
    try {
      const supplierResult = await services.GetSuppliersByItem(skuMasterID, quotationDetails.factoryID);
      setSuppliersAuto(supplierResult);
    } catch (error) {
      alert.error("Error fetching suppliers : ", error);
    }
  }

  async function generateQuotationNumber() {
    let date = new Date();
    let year = date.getFullYear().toString();
    let month = date.getMonth() + 1;
    let dt = date.getDate();
    let hours = date.getHours().toString().padStart(2, '0');
    let minutes = date.getMinutes().toString().padStart(2, '0');
    let dl = hours + minutes;
    year = year.slice(2);
    var maxNumber = 100;
    var randomNumber = Math.floor((Math.random() * maxNumber) + 1);
    let invoiceNo = dl + month + year + randomNumber;
    setQuotationNumber(invoiceNo);
  }

  const uploadSelectedRequisitions = async () => {
    const updatedGroupedData = groupedDate.map((group) => {
      const totalQuantity = group.requisitions.reduce((sum, item) => sum + item.requestedQuantity, 0);
      return {
        ...group,
        groupID: parseInt(quotationDetails.groupID),
        factoryID: parseInt(quotationDetails.factoryID),
        createdBy: parseInt(tokenService.getUserIDFromToken()),
        quantity: totalQuantity,
        suppliers: skuSupplierData[group.skuMasterID] || [],
      };
    });

    const hasMissingSuppliers = updatedGroupedData.some(group => !group.suppliers || group.suppliers.length === 0);

    if (hasMissingSuppliers) {
      alert.error("Supplier is required per SKU");
      return;
    }
    const res = await services.uploadSelectedRequisitions(updatedGroupedData);
    if (res.statusCode === 'Success') {
      alert.success(res.message);
      setSelectedRequisitions([]);
      setQuotationDetailsData([]);
      setSkuSupplierData([]);
      navigate('/app/Quatation/listing');
    } else {
      alert.error(res.message);
    }
  };

  function handleRemoveSupplier(skuMasterID, index) {
    setSkuSupplierData((prevData) => {
      const updatedSuppliers = [...prevData[skuMasterID]];
      updatedSuppliers.splice(index, 1);
      return { ...prevData, [skuMasterID]: updatedSuppliers };
    });
  }

  async function confirmData() {
    if (tableData.requisitionDetailsID !== undefined) {
      setGroupedData((prevData) => {
        return prevData
          .map((group) => {
            const updatedRequisitions = group.requisitions.filter(
              (req) => req.requisitionDetailsID !== tableData.requisitionDetailsID
            );

            return updatedRequisitions.length > 0
              ? { ...group, requisitions: updatedRequisitions }
              : null;
          })
          .filter((group) => group !== null);
      });

      setSelectedRequisitions((prevSelected) =>
        prevSelected.filter(id => id !== tableData.requisitionDetailsID)
      );
    }
    setOpen(false);
  }

  function generateDropDownMenu(data) {
    return Object.entries(data || {}).map(([key, value]) => (
      <MenuItem key={key} value={key}>
        {value}
      </MenuItem>
    ));
  }

  const generateFactoryDropDownMenu = (data) => {
    return data ? data.map(({ id, name }) => (
      <MenuItem key={id} value={id}>{name}</MenuItem>
    )) : [];
  };

  const handleRequisitionSelection = (requisitionDetailsID) => {
    setSelectedRequisitions((prevSelected) => {
      const newSelected = prevSelected.includes(requisitionDetailsID)
        ? prevSelected.filter((num) => num !== requisitionDetailsID)
        : [...prevSelected, requisitionDetailsID];

      setSelectAll(newSelected.length === QuotationDetailsData.length && QuotationDetailsData.length > 0);

      return newSelected;
    });
  };

  function handleChange(e) {
    const { name, value } = e.target;
    setQuotationDetails({ ...quotationDetails, [name]: value });
  }

  function handleSearchDropdownChange(data, e) {
    if (data === undefined || data === null) {
      setQuotationDetails({
        ...quotationDetails,
        requisitionID: 0,
        skuMasterID: 0
      });
      setIsCleared(!isCleared)
      return;
    } else {
      var valueV = data["requisitionID"];
      setQuotationDetails({
        ...quotationDetails,
        requisitionID: valueV.toString(),
        skuMasterID: 0
      });
      setQuotationDetailsData([]);
      setIsCleared(!isCleared)
    }
  }

  function handleSearchDropdownChangeSKU(data, e) {
    if (data === undefined || data === null) {
      setQuotationDetails({
        ...quotationDetails,
        skuMasterID: 0,
      });
      return;
    } else {
      var valueV = data["skuMasterID"];
      setQuotationDetails({
        ...quotationDetails,
        skuMasterID: valueV.toString()
      });
      setQuotationDetailsData([]);
    }
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
        <Grid item md={2} xs={12}>
          <PageHeader
            onClick={handleClick}
          />
        </Grid>
      </Grid>
    );
  }

  return (
    <Page className={classes.root} title={title}>
      <LoadingComponent />
      <Container maxWidth={false}>
        <Formik
          initialValues={quotationDetails}
          validationSchema={Yup.object({
            groupID: Yup.number().required('Group is required').min(1, 'Group is required'),
            factoryID: Yup.number().required('Factory is required').min(1, 'Factory is required'),
          })}
          onSubmit={getQuotationDetails}
          enableReinitialize
        >
          {({ handleSubmit, errors, touched }) => (
            <form onSubmit={handleSubmit}>
              <Card>
                <CardHeader title={cardTitle(title)} />
                <Divider />
                <CardContent style={{ marginBottom: '2rem' }}>
                  <Grid container spacing={3}>
                    <Grid item md={4} xs={12}>
                      <InputLabel shrink id="groupID">
                        Group *
                      </InputLabel>
                      <TextField
                        select
                        name="groupID"
                        value={quotationDetails.groupID}
                        onChange={handleChange}
                        error={touched.groupID && Boolean(errors.groupID)}
                        helperText={touched.groupID && errors.groupID}
                        fullWidth
                        variant="outlined"
                        size="small"
                      >
                        <MenuItem value="0">--Select Group--</MenuItem>
                        {generateDropDownMenu(groups)}
                      </TextField>
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <InputLabel shrink id="factoryID">
                        Factory *
                      </InputLabel>
                      <TextField select
                        error={Boolean(touched.factoryID && errors.factoryID)}
                        helperText={touched.factoryID && errors.factoryID}
                        fullWidth
                        name="factoryID"
                        onChange={(e) => handleChange(e)}
                        value={quotationDetails.factoryID}
                        variant="outlined"
                        size="small"
                      >
                        <MenuItem value="0">--Select Factory--</MenuItem>
                        {generateFactoryDropDownMenu(factories)}
                      </TextField>
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <InputLabel shrink id="requisitionID">
                        Requisition No
                      </InputLabel>
                      <Autocomplete
                        id="requisitionID"
                        key={isCleared}
                        options={requisitions}
                        getOptionLabel={(option) => option.requisitionNumber}
                        onChange={(e, value) => handleSearchDropdownChange(value, e)}
                        value={requisitions.find(req => req.requisitionID == quotationDetails.requisitionID) || null}
                        renderInput={(params) =>
                          <TextField {...params} placeholder="--Select Requisition No--"
                            error={Boolean(touched.requisitionID && errors.requisitionID)}
                            helperText={touched.requisitionID && errors.requisitionID}
                            variant="outlined"
                            name="requisitionID"
                            fullWidth
                            size='small'
                            value={quotationDetails.requisitionID}
                            getOptionDisabled={true}
                          />
                        }
                      />
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <InputLabel shrink id="skuMasterID">
                        SKU
                      </InputLabel>
                      <Autocomplete
                        id="skuMasterID"
                        key={isCleared}
                        options={skuMaster}
                        getOptionLabel={(option) => option.skuMasterName}
                        onChange={(e, value) => handleSearchDropdownChangeSKU(value, e)}
                        value={skuMaster.find(sku => sku.skuMasterID == quotationDetails.skuMasterID) || null}
                        renderInput={(params) =>
                          <TextField {...params} placeholder="--Select SKU--"
                            error={Boolean(touched.skuMasterID && errors.skuMasterID)}
                            helperText={touched.skuMasterID && errors.skuMasterID}
                            variant="outlined"
                            name="skuMasterID"
                            fullWidth
                            size='small'
                            value={quotationDetails.skuMasterID}
                            getOptionDisabled={true}
                          />
                        }
                      />
                    </Grid>
                    <Grid container justify="flex-end" spacing={3}>
                      <Box pr={2} style={{ marginTop: '20px' }}>
                        <Button
                          color="primary"
                          type="submit"
                          variant="contained"
                          size="small"
                        >
                          Search
                        </Button >
                      </Box>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </form>
          )}
        </Formik>
        {QuotationDetailsData.length > 0 ?
          <PerfectScrollbar>
            <MaterialTable
              title="Quotation Details"
              columns={[
                {
                  title: "",
                  field: "selection",
                  sorting: false,
                  filtering: false,
                  headerStyle: { width: '80px', textAlign: 'center', paddingLeft: '16px' },
                  cellStyle: { textAlign: 'center', paddingLeft: '16px' },
                  render: (rowData) => (
                    <Checkbox
                      checked={selectedRequisitions.includes(rowData.requisitionDetailsID)}
                      onChange={() => handleRequisitionSelection(rowData.requisitionDetailsID)}
                      color="primary"
                    />
                  ),
                },
                { title: "Requisition Number", field: "requisitionNumber" },
                { title: "Factory", field: "factoryName" },
                { title: "Account Code", field: "budgetCode" },
                { title: "SKU", field: "skuMasterName" },
                {
                  title: 'Quantity',
                  field: 'requestedQuantity',
                  render: rowData => rowData.requestedQuantity.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                  cellStyle: {
                    textAlign: 'right',
                    paddingRight: '100px',
                  },
                },
              ]}
              data={QuotationDetailsData}
              options={{
                actionsColumnIndex: -1,
                selection: false,
                showSelectAllCheckbox: false,
                toolbar: true,
                paging: false,
              }}
              components={{
                Header: (props) => (
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ width: '80px', textAlign: 'center', paddingLeft: '16px' }}>
                        <Checkbox
                          checked={selectAll}
                          onChange={handleSelectAll}
                          indeterminate={selectedRequisitions.length > 0 && selectedRequisitions.length < QuotationDetailsData.length}
                          color="primary"
                        />
                      </TableCell>
                      <TableCell>Requisition Number</TableCell>
                      <TableCell>Factory</TableCell>
                      <TableCell>Account Code</TableCell>
                      <TableCell>SKU</TableCell>
                      <TableCell style={{ textAlign: 'right', paddingRight: '100px' }}>Quantity</TableCell>
                    </TableRow>
                  </TableHead>
                ),
              }}
            />
            <br></br>
            {groupedDate.map((skuGroup) => (
              <div key={skuGroup.skuMasterID}>
                <br></br>
                <Card>
                  <Grid item xs={12} style={{ marginBottom: "20px", marginTop: "20px" }}>
                    <Grid container direction="row" spacing={2} style={{ marginLeft: "10px" }}>
                      <Grid item style={{ marginTop: "20px" }}>
                        <Chip color="secondary" label={skuGroup.skuMasterName} />
                      </Grid>
                      <Grid item md={3} xs={8}>
                        <InputLabel shrink id="supplierID">
                          Supplier *
                        </InputLabel>
                        <Autocomplete
                          id="supplierID"
                          key={isCleared}
                          options={suppliersAuto || []}
                          getOptionLabel={(option) => option?.supplierName || " "}
                          onOpen={() => getSuppliersForDropDownAuto(skuGroup.skuMasterID)}
                          onChange={(e, value) => handleSupplier(value, e, skuGroup.skuMasterID)}
                          value={null}
                          renderInput={(params) => (
                            <TextField {...params}
                              variant="outlined"
                              fullWidth
                              size="small"
                              placeholder="--Select Supplier--" />
                          )}
                        />
                      </Grid>
                      <Grid item style={{ marginTop: "20px" }}>
                        <div style={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
                          {skuSupplierData[skuGroup.skuMasterID]?.map((supplier, index) => (
                            <Chip
                              key={index}
                              label={supplier.supplierName}
                              className="supplier-chip"
                              onDelete={() => handleRemoveSupplier(skuGroup.skuMasterID, index)}
                              deleteIcon={<span style={{ fontSize: '16px', fontWeight: 'bold' }}>x</span>}
                            />
                          ))}
                        </div>
                      </Grid>
                    </Grid>
                    <Table className={classes.table} aria-label="caption table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Requisition Number</TableCell>
                          <TableCell>Factory</TableCell>
                          <TableCell>Account Code</TableCell>
                          <TableCell>SKU</TableCell>
                          <TableCell style={{ textAlign: "right" }}>Quantity</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {skuGroup.requisitions.slice(
                          (pagination[skuGroup.skuMasterID]?.page || 0) * (pagination[skuGroup.skuMasterID]?.limit || 5),
                          (pagination[skuGroup.skuMasterID]?.page || 0) * (pagination[skuGroup.skuMasterID]?.limit || 5) + (pagination[skuGroup.skuMasterID]?.limit || 5))
                          .map((requisition, index) => (
                            <TableRow key={index}>
                              <TableCell>{requisition.requisitionNumber}</TableCell>
                              <TableCell>{requisition.factoryName}</TableCell>
                              <TableCell>{requisition.budgetCode}</TableCell>
                              <TableCell>{requisition.skuMasterName}</TableCell>
                              <TableCell style={{ textAlign: "right" }}>{(requisition.requestedQuantity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                      <TableRow>
                        <TableCell colSpan={4} style={{ textAlign: "left", fontWeight: "bold" }}>Total</TableCell>
                        <TableCell style={{ textAlign: "right", fontWeight: "bold" }}>
                          {(skuGroup.requisitions.reduce((total, requisition) => total + requisition.requestedQuantity, 0)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </TableCell>
                      </TableRow>
                    </Table>
                    <TablePagination
                      component="div"
                      count={skuGroup.requisitions.length}
                      page={pagination[skuGroup.skuMasterID]?.page || 0}
                      rowsPerPage={pagination[skuGroup.skuMasterID]?.limit || 5}
                      onChangePage={(event, newPage) => handlePageChange(skuGroup.skuMasterID, newPage)}
                      onChangeRowsPerPage={(event) => handleLimitChange(skuGroup.skuMasterID, event)}
                      rowsPerPageOptions={[5, 10, 25]}
                    />
                  </Grid>
                </Card>
              </div>
            ))}
            <Box mt={2} display="flex" justifyContent="flex-end">
              <Button color="primary" variant="contained" onClick={uploadSelectedRequisitions}
                disabled={groupedDate.length === 0}>
                Create Quotation
              </Button>
            </Box>
          </PerfectScrollbar>
          : null}
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setOpen(false)}
        >
          <DialogTitle>
            {'Are you sure you want to delete this record?'}
          </DialogTitle>
          <DialogActions>
            <Button onClick={() => setOpen(false)} color="primary">
              Cancel
            </Button>
            <Button onClick={confirmData} color="primary">
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Page>
  );
}